export default __webpack_public_path__ + "static/media/CivilEng_Shapes-05.73104c84.png";